import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const PersonalInformationWeCollect = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row
      title="Personal Information We Collect"
      onToggle={onToggle}
      isShow={isShow}
    >
      <div>
        Medcursor collects information from those who communicate with us, website
        visitors, and from website visitors that purchase products from us.
        Medcursor also collects information from its social media pages.
        <div className="font-bold mt-4">
          a. Information Collected By Communications
        </div>
        <div className="pt-2">
          We may collect information from individuals that submit information to
          us using phone, email, and postal mail, including name, phone number,
          email address, postal address, and voice or message content.
        </div>
        <div>
          The www.medcursor.com website’s web form collects name, email address,
          subject, and your message.
        </div>
        <div className="font-bold mt-4">
          b. Information Collected by Website Visitors
        </div>
        <div className="pt-2">
          Medcursor collects some categories of information from website visitors
          automatically, as described in this section.
        </div>
        <div className="p-5">
          <div className="font-bold">
            i. Information Collected from Visitors In General
          </div>
          <div className="pt-2">
            We may collect the following information about website visitors (on
            an aggregate or individual basis):
          </div>
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>Visitors' Internet protocol (IP) addresses</li>
            <li>Locations of visitors</li>
            <li>The MAC address of visitors’ devices</li>
            <li>Web browser users are using</li>
            <li>Operating systems used by visitors</li>
            <li>
              Key words or search terms used by visitors to find our website
            </li>
            <li>How many visitors div the website or specific pages on it</li>
            <li>
              Internet activity information showing how visitors div and use our
              website, including a history of what pages and products they
              browse, the search terms they put into the website, and what they
              click on
            </li>
          </ul>
          <div>
            We maintain records of those interested in our company who use the
            live chat feature on the website to communicate with us.
          </div>
          <div>
            We use Google Analytics, which is a service of Google LLC. Google
            Analytics allows us to gather the above information about our
            website’s users.
          </div>
        </div>
        <div className="font-bold">
          c. Information Collected from Users and User Devices
        </div>
        <div className="p-2">
          <div className="font-bold">
            i. Information Collected in Connection with Purchases
          </div>
          When you obtain a Medcursor mobile application, before you can operate
          the application, we collect the information about your device (which
          is not personal information):
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>Mobile phone operating system</li>
            <li>Mobile phone brand</li>
            <li>Version of the Medcursor app downloaded</li>
            <li>Device setting for time zone</li>
            <li>Timestamp of the date and time of the download</li>
            <li>
              Security token and Session ID data for authentication purposes
            </li>
          </ul>
        </div>
        <div className="p-2">
          When you purchase products using the Medcursor mobile application, we
          ask users to provide the following categories of personal information
          for their account profile associated with the Medcursor mobile
          application:
          <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
            <li>First and last name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>A user-selected password</li>
            <li>Postal address (shipping and billing)</li>
            <li>Payment information</li>
            <li>Date of birth</li>
          </ul>
        </div>
        <div className="mt-4">
          We maintain a purchase history of the products you have purchased
          using the Medcursor mobile application.
        </div>
        <div className="mt-4">
          Our electronic commerce site collects payment card or banking
          information to complete product purchases. Nonetheless, payments are
          processed by or payment service providers, PayPal and Stripe.
          Accordingly, we do not have access to your payment card information.
        </div>
        <div className="mt-4">
          When creating a profile, we may also ask if you would like to receive
          our newsletter and other marketing communications. If you check the
          box to receive such communications, we use the email address in your
          user profile to send these communications.
        </div>
        <div className="font-bold mt-4 mb-2">ii. User Data</div>
        Our product partners’ smart devices collect information through sensors
        and also via users’ inputting data. Some smart devices collect
        information that is not personal information. For instance, temperature
        sensors measure surface temperatures of objects and materials. Other
        smart devices collect personal information, such as weight, blood
        pressure, and fitness information. For some devices, like scales and
        cookers, our applications may collect your personal information, such as
        your gender, weight, height, birthday, BMI (Body Mass Index), food, and
        nutritional ingredients to provide full features of our services. When
        sensors collect personal information, Medcursor receives, stores, and
        maintains the information. Users may div and manage the collected
        personal information using a Medcursor online account accessible through a
        Medcursor mobile application.
        <div className="mt-4">
          We may periodically send promotional emails about new products,
          special offers or other information that we think you may find
          interesting using the email address which you have provided. Upon
          registering you can select whether or not you will receive such
          communications, and can change your preference at any time.
          Nonetheless, if you opt out of such communications, we will still
          communicate with you regarding your orders, for account
          administration, for customer support purposes, or for security
          purposes.
        </div>
        <div className="mt-4">
          When you seek support from us, when you contact us, or when you use
          Medcursor mobile application, we may collect your IP address, your
          location information, such as longitude and latitude, time zone
          settings, region, country, etc.. We also collect information about the
          history of operation of the Medcursor -compatible devices you purchase,
          including errors, history of logging in, your schedule settings, and
          input records. We may also collect technical information to help us
          identify your device for diagnostic purposes and fraud prevention.
        </div>
        <div className="mt-4">
          We may also collect other personal information when you use a device
          or our services in ways that we describe at the point of collection or
          otherwise with your separate consent when required, such as
          environmental characteristics value (ECV).
        </div>
        <div className="font-bold mt-4 pb-2">
          iii. Information Collected By Our Social Media Pages
        </div>
        When you post information on our social media pages on one of the social
        media platforms, we will be able to div the content in your post (e.g.,
        text, photo, audio, or video). We will also be able to div your user
        name and information that you record on your profile on that platform.
      </div>
    </Row>
  );
};
